import { Component, OnInit } from '@angular/core';
import { StateService } from '@uirouter/angular';
import { NgbModalRef } from '@ng-bootstrap/ng-bootstrap';
import { JhiEventManager } from 'ng-jhipster';

import { Account, LoginModalService, Principal } from '../shared';
import { AuthService } from '../shared/auth/auth.service';
import { JhiLanguageHelper } from '../shared/language/language.helper';

@Component({
    selector: 'jhi-home',
    templateUrl: './home.component.html',
    styleUrls: ['home.component.scss'],
})
export class HomeComponent implements OnInit {
    account: Account;
    modalRef: NgbModalRef;

    currentLang = 'fr';

    constructor(
        private principal: Principal,
        private $state: StateService,
        private loginModalService: LoginModalService,
        private languageHelper: JhiLanguageHelper,
        private eventManager: JhiEventManager,
        private authService: AuthService
    ) {}

    ngOnInit() {
        this.currentLang = this.languageHelper.getCurrentLang();

        this.languageHelper.languageChange.subscribe((languageKey) => {
            this.currentLang = languageKey;
            setTimeout(() => {
                this.authService.login(languageKey);
            }, 5);
        });

        this.principal.identity().then((account) => {
            this.account = account;
            if (!account) {
                this.authService.login();
            }
        });
        this.registerAuthenticationSuccess();
    }

    registerAuthenticationSuccess() {
        this.eventManager.subscribe('authenticationSuccess', (message) => {
            this.principal.identity().then((account) => {
                this.account = account;
            });
        });
    }

    isAuthenticated() {
        return this.principal.isAuthenticated();
    }

    login() {
        this.authService.login();
    }
}



// WEBPACK FOOTER //
// ./src/app/home/home.component.ts